<template>
    <div class="box">
        <div class="box-left">
            <my-form
                v-model="form"
                autocomplete="off"
                label-width="80px"
                @submit="submitHandler"
            >
                <el-form-item
                    label="计算额"
                    prop="costlimit"
                    :rules="newRule('计算额', 'required')"
                >
                    <el-input
                        class="login-input"
                        v-model="form.costlimit"
                        oninput="value=value.replace(/[^0-9.]/g,'')"
                        clearable
                        autocomplete="off"
                        :placeholder="`请输入计算额`"
                    >
                        <template slot="append">万元</template>
                    </el-input>
                </el-form-item>

                <el-form-item
                    label="设置行业"
                    prop="industryratio"
                    :rules="newRule('行业', 'required')"
                >
                    <el-select
                        v-model="form.industryratio"
                        @change="industryratioHandler"
                        placeholder="请选择"
                        class="select"
                    >
                        <el-option
                            v-for="item in options"
                            :key="item.industryid"
                            :label="item.industryname"
                            :value="item.industryid"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item
                    label="设置专业"
                    prop="professional"
                    :rules="newRule('专业', 'required')"
                >
                    <el-select
                        v-model="form.professional"
                        placeholder="请选择"
                        class="select"
                    >
                        <el-option
                            v-for="item in professionalArr"
                            :key="item.industryid"
                            :label="item.industryname"
                            :value="item.ratio"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>

                <span class="coefficient"
                    >专业调整系数：{{ form.professional }}</span
                >

                <el-form-item
                    label="设置高程"
                    prop="elevation"
                    :rules="newRule('高程', 'required')"
                >
                    <el-select
                        v-model="form.elevation"
                        placeholder="请选择"
                        class="select"
                    >
                        <el-option
                            v-for="item in elevationArr"
                            :key="item.industryid"
                            :label="item.industryname"
                            :value="item.ratio"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>

                <span class="coefficient"
                    >高程调整系数：{{ form.elevation }}</span
                >

                    <div class="professional-level">
                        <el-form-item
                            label="设置专业"
                            prop="professionalComplex"
                            :rules="newRule('专业', 'required')"
                            class="professional-level-box"
                        >
                            <el-select
                                v-model="form.professionalComplex"
                                @change="professionalComplexHandler"
                                placeholder="请选择"
                                class="select"
                            >
                                <el-option
                                    v-for="item in professionalComplexArr"
                                    :key="item.industryid"
                                    :label="item.industryname"
                                    :value="item.industryid"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item
                            label="复杂等级"
                            prop="levelId"
                            :rules="newRule('复杂等级', 'required')"
                            class="professional-level-box"
                        >
                            <el-select
                                v-model="form.levelId"
                                @change="levelHandler"
                                placeholder="请选择"
                                class="select"
                            >
                                <el-option
                                    v-for="item in levelArr"
                                    :key="item.industryid"
                                    :label="item.industryname"
                                    :value="item.industryid"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <span class="professional-level-num"
                        >复杂程度调整系数系数：{{ form.level }}</span
                    >

                    <el-form-item
                        label="折扣"
                        prop="discount"
                        :rules="newRule('折扣', 'required')"
                    >
                        <el-input
                            class="login-input"
                            v-model="form.discount"
                            @change="discountHandler"
                            clearable
                            type="number"
                            min="0"
                            autocomplete="off"
                            :placeholder="`请输入折扣`"
                        >
                            <template slot="append">%</template>
                        </el-input>
                    </el-form-item>

                <template slot="btn" slot-scope="scope">
                  <div class="btn-login">
                    <el-button
                      type="primary"

                      @click="scope.submitHandler"
                    >
                      开始计算
                    </el-button>
                  </div>
                </template>
            </my-form>
        </div>

        <div class="box-right">
          <div class="computed-result">
            <div>折扣后监理费：<span>{{discountCost}}</span> 万元</div>
            <div>标准监理费：<span>{{standardCost}}</span> 万元</div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                costlimit: "", //计算额
                industryratio: "", //行业
                professional: "", //专业
                discount: 100, //折扣
                professionalComplex: "", //专业(复杂)
                level: "", //复杂等级
                levelId: "", //复杂等级id
                elevation: "", //高程
            },

            options: [],    //行业选择数组
            professionalArr: [], //专业选择数组
            elevationArr: [],   //高程数组
            professionalComplexArr: [], //专业(复杂)数组
            levelArr: [], //复杂等级数组

            leavelAll: [], //所有复杂等级数组

            discountCost: "0", //折扣后监理费用
            standardCost: "0", //标准监理费用
        };
    },
    methods: {
        /**
         * 监理计算提交
         */
        submitHandler() {
            this.$get(
                `${this.$store.state.api.webUrl}/navigation/getCalculateData.json`,
                {
                    costlimit: this.form.costlimit,
                    industryratio: this.form.professional,
                    elevationratio: this.form.elevation,
                    complexityratio: this.form.level,
                    discount: this.form.discount,
                    type: "TYPE3",
                },
                (data) => {
                    this.discountCost = data.discount;
                    this.standardCost = data.standard;
                }
            );
            this.$emit('startCompute');
        },
        /**
         * 折扣输入框 change 事件
         */
        discountHandler() {
            if (this.form.discount < 0) {
                this.form.discount = 0;
            }
          let discountStr = String(this.form.discount)
          discountStr = discountStr.replace(/[^\d.]/g, "")
            .replace(/^0\d+|^\./g, "")
            .replace(/\.{2,}/g, ".")
            .replace(".", "$#$")
            .replace(/\./g, "")
            .replace("$#$", ".")
            .replace(/^(\d+)\.(\d\d).*$/, "$1.$2");
          this.form.discount = parseFloat(discountStr) || 0;
        },
        /**
         * 行业选择框 change 事件
         */
        industryratioHandler() {
            this.queryData(this.form.industryratio)
        },

        /**
         * 设置专业(复杂)选择框 change 事件
         */
        professionalComplexHandler() {
            const that = this;
            // 设置复杂等级下拉框数组
            that.levelArr = that.leavelAll.filter(function (val) {
                return val.parentid == that.form.professionalComplex;
            });
            // 设置复杂等级默认选中项(默认第一项)
            that.form.levelId = that.levelArr[0].industryid;
            // 设置复杂程度调整系数系数(默认第一项)
            that.form.level = that.levelArr[0].ratio
        },

        /**
         * 复杂等级选择框 change 事件
         */
        levelHandler() {
            const that = this;
            if (that.form.levelId) {
                var arr = that.levelArr.filter(function (val) {
                    return val.industryid == that.form.levelId;
                })[0];
                that.form.level = arr.ratio;
                that.form.addition = arr.addition;
            } else {
                that.form.level = "";
            }
        },

        /**
         * 获取数据
         * @param {String} 行业id
         */
        queryData(id) {
            this.$get(
                `${this.$store.state.api.webUrl}/navigation/getSupervisorAll.json`,{
                    id:id,
                },
                (data) => {
                    this.options = data.select1;
                    this.professionalArr = data.select2;
                    this.elevationArr = data.select3;
                    this.professionalComplexArr = data.select4;
                    this.leavelAll = data.select5;
                    var levelId = data.select4[0].industryid;
                    this.levelArr = data.select5.filter(function(val){
                        return val.parentid == levelId
                    })

                    // 初始化
                    if(id == '1'){
                        this.form.industryratio = data.select1[0].industryid;
                    }
                    this.form.professional = data.select2[0].ratio;
                    this.form.elevation = data.select3[0].ratio
                    this.form.professionalComplex = data.select4[0].industryid;
                    this.form.level = data.select5[0].ratio;
                    this.form.levelId = data.select5[0].industryid;
                }
            );
        },
    },
    mounted() {
        this.queryData("1");
    },
};
</script>

<style lang="scss" scoped>
.box {
    width: 100%;
    box-sizing: border-box;
    position: relative;
    .coefficient {
        display: block;
        margin-top: -6px;
        margin-left: 80px;
        margin-bottom: 12px;
        color: #606266;
    }
    .select {
        width: 100%;
    }
    .discount {
        position: absolute;
        left: 451px;
        top: 74px;
        width: 400px;
    }

    .btn-login {
      display: flex;
      justify-content: center;
    }

    .professional-level {
        width: 100%;
        height: 32px;
    }
    .professional-level-box {
        float: left;
        width: 200px;
        margin-bottom: 10px;
        // height: 40px;
    }
    .professional-level-num {
        display: block;
        // margin-top: -6px;
        margin-left: 80px;
        margin-bottom: 10px;
        color: #606266;
    }
    .professional-level-coefficient{
        position: absolute;
        width: 400px;
        top: 0px;
        left: 451px;
    }
}
.box > div {
    float: left;
    width: 400px;
}

.box-right {
    margin-top: 0;
    margin-left: 100px;
    width: 520px !important;

    .box-right-cost {
        margin-bottom: 20px;
    }
}

.computed-result{
  margin-top: -55px;
  font-size: 17px;
  font-weight: 600;
  color: #606266;
  div{
    margin-bottom: 15px;
  }
  span{
    color: red;
  }
}
</style>
